import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const TurnSchema = () =>
  yup.object({
    iD_Shift: yup.number().label(i18n2._('ID')),
    name: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Nombre')),
    schedule: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Horario')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
